<template>
  <div>
    <panel>
      <h2>UM</h2>

      <div class="row">
        <w-input class="col-12 mb-5" :model="$schema.systemNumbers.mdok" />

        <w-input class="col-12 mb-5" :model="$schema.systemNumbers.mdokId" />

        <w-input class="col-12 mb-5" :model="$schema.systemNumbers.sign" />

        <w-input class="col-12 mb-5" :model="$schema.systemNumbers.caseId" />
      </div>

      <div v-if="!hideJo">
        <h2>JO</h2>

        <div class="row">
          <w-input class="col-12 mb-5" :model="$schema.systemNumbers.mdokJo" />

          <w-input class="col-12 mb-5" :model="$schema.systemNumbers.mdokJoId" />

          <w-input class="col-12 mb-5" :model="$schema.systemNumbers.signJo" />

          <w-input class="col-12 mb-5" :model="$schema.systemNumbers.caseJoId" />
        </div>
      </div>
    </panel>

    <check-permission permissions="COMMENT.UPDATE">
      <comment :model="$schema.comment" />
    </check-permission>

    <w-button class="btn-primary float-right" text="Zapisz" @click="save" />
  </div>
</template>

<script>
import { tryParseBoolean } from '@witkac/utils/tryParseBoolean';
import { mapState } from 'vuex';

import Comment from '@/components/formComponents/Comment.vue';
import Panel from '@/components/panel/Panel';
import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { Successes } from '@/enums/successes.enum';
import { editMixin } from '@/mixins/edit';
import schema from '@/schemas/systemNumbers.schema';

// @vuese
// Komponent do zarządzania numerami systemowymi dokumentu
// @group Document
export default {
  components: { Comment, Panel },
  mixins: [editMixin('document')],
  schema,
  computed: mapState({
    stateData: state => {
      const document = state.document.data;
      if (!document.systemNumbers) {
        document.systemNumbers = {};
      }
      return document;
    },

    hideJo: state => tryParseBoolean(state.setting.settings[PublicSettings.HIDE_JO_SYSTEM_NUMBERS]?.value, false)
  }),
  methods: {
    // @vuese
    // Zapisuje dane
    save() {
      const model = { ...this.$schema.$getData(), id: this.id };
      this.$store
        .dispatch(`document/updateSystemNumbers`, model)
        .then(entityId => this.notifySuccess(Successes.DOCUMENT_NUMBERS_SAVED))
        .catch(err => this.notifyError(Errors.FORM_CANNOT_SAVE));
    }
  }
};
</script>
